/*
 * Copyright (c) 2019 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can/util/util';
import Component from 'can/component/component';
import template from './cell-channel.stache';

import dateTimeUtil from 'scripts/utils/date-time';

Component.extend({
    tag: 'viewing-schedule-table-cell-channel',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            event: {
                Type: can.Map,
                Value: can.Map,
            },
        },
        hasLink() {
            const channelFinderLink = this.attr('event').channelFinderLink;
            return (
                channelFinderLink != null &&
                channelFinderLink.url != null &&
                channelFinderLink.title != null
            );
        },
        getTimeWithMeridian: dateTimeUtil.getTimeWithMeridian,
    },
});
